import { useCallback, useEffect, useState } from "react";
import { apiUrl } from "utils/apiUrl";

const CACHE_MS = 60_000;
const cache = new Map();

/**
 * @param {"public" | "client"} audience
 */
export default function useSiteHeaderMessages(audience = "public") {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const key = audience;
    const hit = cache.get(key);
    if (hit && Date.now() - hit.at < CACHE_MS) {
      setMessages(hit.messages);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        apiUrl(
          `/api/public/site-header-messages?audience=${encodeURIComponent(audience)}`,
        ),
      );
      const data = await res.json().catch(() => ({}));
      const list = res.ok && data.ok && Array.isArray(data.messages) ? data.messages : [];
      cache.set(key, { at: Date.now(), messages: list });
      setMessages(list);
    } catch {
      setMessages([]);
    } finally {
      setLoading(false);
    }
  }, [audience]);

  useEffect(() => {
    load();
  }, [load]);

  return { messages, loading, reload: load };
}

export function invalidateSiteHeaderMessagesCache() {
  cache.clear();
}
